module.exports = __webpack_public_path__ + "static/media/hackillinois.bcc019d9.svg";